import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { ASSETS } from '../../../lib/assets';
export function CurriculumScreen({
  onBack,
  onNext
}: {
  onBack: () => void;
  onNext: () => void;
}) {
  return <section className="flex h-full flex-col px-4 pb-4 pt-2 text-[#13587a]" data-id="element-50" data-mp="2zaesdbaiap0b">
      <div className="flex items-center justify-between" data-id="element-51" data-mp="348yh1jghiewd">
        <button onClick={onBack} className="flex items-center rounded-full bg-[#5b5268]/85 px-2 py-1 text-[10px] text-white" data-id="element-52" data-mp="346c8phlrrvd3"><ChevronLeft className="h-3.5 w-3.5" data-id="element-53" data-mp="27gcsd0zdnsjy" />Back</button>
        <button onClick={onNext} className="flex items-center rounded-full bg-[#5b5268]/85 px-2 py-1 text-[10px] text-white" data-id="element-54" data-mp="2bkapj6556tad">Next<ChevronRight className="h-3.5 w-3.5" data-id="element-55" data-mp="2ggrd9z8fj5mx" /></button>
      </div>
      <p className="mx-auto mt-5 max-w-[255px] text-center text-[11px] font-semibold leading-relaxed" data-id="element-56" data-mp="2lacee05bkfqc">This section will give you a glimpse into one lesson, from one of the modules, under each umbrella: <strong data-id="element-57" data-mp="1ss86xp8xx2xh">SELF, SOCIETY, ECOLOGY.</strong></p>
      <div className="relative mx-auto mt-5 h-[305px] w-[280px]" data-id="element-58" data-mp="1sqx2dn7o7r5b">
        <div className="absolute inset-5 rounded-full border-2 border-dotted border-[#233e51]" data-id="element-59" data-mp="17lkv9zb0iidg" />
        <Topic image={ASSETS.self} label="SELF" className="right-1 top-2" rotate="55deg" data-id="element-60" data-mp="13l0ywxy9jisd" />
        <Topic image={ASSETS.ecology} label="ECOLOGY" className="left-0 top-24" rotate="-25deg" data-id="element-61" data-mp="yshjdvg0mdkx" />
        <Topic image={ASSETS.society} label="SOCIETY" className="bottom-1 right-8" rotate="12deg" data-id="element-62" data-mp="ttwkq0gew1yl" />
      </div>
      <p className="mx-auto mt-auto max-w-[220px] text-center text-[10px] font-semibold leading-snug" data-id="element-63" data-mp="ox63h9svf0bl">For access to the full version, please create an account and subscribe!</p>
    </section>;
}
function Topic({
  image,
  label,
  className,
  rotate
}: {
  image: string;
  label: string;
  className: string;
  rotate: string;
}) {
  return <button aria-label={`Explore ${label}`} className={`absolute flex w-28 flex-col items-center ${className}`} data-id="element-64" data-mp="ay6eu25cylff"><span className="grid h-20 w-20 place-items-center rounded-full bg-[#bd8ba6]/75" data-id="element-65" data-mp="259uy2gimha5m"><img src={image} alt="" className="h-16 w-16 rounded-full object-cover" data-id="element-66" data-mp="257ryb4ro42np" /></span><span className="mt-1 font-display text-sm font-extrabold tracking-wide" style={{
      transform: `rotate(${rotate})`
    }} data-id="element-67" data-mp="2ocws6sujjk4e">{label}</span></button>;
}